module.exports = __webpack_public_path__ + "static/media/mobile-m.3cc5e17c.jpg";